/**
 * Generated from ch2_p08.fla
 */
export function ch2_p08(this: Ich2_p08) {
	const hollyBack = this.hollyBack;
	if (!hollyBack[0] && hollyBack.elementFactory) {
		hollyBack[0] = hollyBack.elementFactory(0,undefined);
	}
	if (hollyBack[0]) {
		ch2_p08_hh_ch2_p08psdAssetP8Holly.call(hollyBack[0] as Ich2_p08_hh_ch2_p08psdAssetP8Holly);
		hollyBack[0].x = 412.75;
		hollyBack[0].y = 768;
		hollyBack[0].width = 340.50;
		hollyBack[0].height = 517.00;
		hollyBack[0].alpha = 1;
		if (hollyBack[0].onLayout) hollyBack[0].onLayout();
	}
	if (!hollyBack[1] && hollyBack.elementFactory) {
		hollyBack[1] = hollyBack.elementFactory(1,undefined);
	}
	if (hollyBack[1]) {
		ch2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyback.call(hollyBack[1] as Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyback);
		hollyBack[1].x = 446.5;
		hollyBack[1].y = 604.2;
		hollyBack[1].width = 348.00;
		hollyBack[1].height = 327.50;
		hollyBack[1].alpha = 1;
		if (hollyBack[1].onLayout) hollyBack[1].onLayout();
	}
	const hollyFront = this.hollyFront;
	if (!hollyFront[0] && hollyFront.elementFactory) {
		hollyFront[0] = hollyFront.elementFactory(0,undefined);
	}
	if (hollyFront[0]) {
		ch2_p08_hh_ch2_p08psdAssetP8hollyarms.call(hollyFront[0] as Ich2_p08_hh_ch2_p08psdAssetP8hollyarms);
		hollyFront[0].x = 438;
		hollyFront[0].y = 688;
		hollyFront[0].width = 273.00;
		hollyFront[0].height = 276.00;
		hollyFront[0].alpha = 1;
		if (hollyFront[0].onLayout) hollyFront[0].onLayout();
	}
	if (!hollyFront[1] && hollyFront.elementFactory) {
		hollyFront[1] = hollyFront.elementFactory(1,undefined);
	}
	if (hollyFront[1]) {
		ch2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyfront.call(hollyFront[1] as Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyfront);
		hollyFront[1].x = 559.65;
		hollyFront[1].y = 556.4;
		hollyFront[1].width = 362.49;
		hollyFront[1].height = 248.94;
		hollyFront[1].alpha = 1;
		if (hollyFront[1].onLayout) hollyFront[1].onLayout();
	}
	const bg = this.bg;
	ch2_p08_hh_ch2_p08psdAssetP8bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const chairs = this.chairs;
	ch2_p08_hh_ch2_p09psdAsset1chp2_p09_hollytablechairs.call(this.chairs);
	chairs.x = 822;
	chairs.y = 627.2;
	chairs.width = 1167.00;
	chairs.height = 281.50;
	chairs.alpha = 1.00;
	if (chairs.onLayout) chairs.onLayout();
	const table = this.table;
	ch2_p08_hh_ch2_p08psdAssetP8table.call(this.table);
	table.x = 836;
	table.y = 768;
	table.width = 794.00;
	table.height = 166.00;
	table.alpha = 1.00;
	if (table.onLayout) table.onLayout();
	const phone = this.phone;
	ch2_p08_hh_ch2_p08psdAsset1P8phone.call(this.phone);
	phone.x = 711.5;
	phone.y = 673.2;
	phone.width = 113.00;
	phone.height = 27.50;
	phone.alpha = 1.00;
	if (phone.onLayout) phone.onLayout();
	const frameLeft = this.frameLeft;
	ch2_p08_hh_ch2_p08psdAssetP8frameL.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 1286.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const frameRight = this.frameRight;
	ch2_p08_hh_ch2_p08psdAssetP8frameR.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 1127.50;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const lines = this.lines;
	ch2_p08_hh_ch2_p08psdAssetP8framelines.call(this.lines);
	lines.x = 832;
	lines.y = 384.25;
	lines.width = 1664.00;
	lines.height = 767.50;
	lines.alpha = 1.00;
	if (lines.onLayout) lines.onLayout();
	const sigh = this.sigh;
	ch2_p08_hh_ch2_p09psdAssetchp2_p09_sigh.call(this.sigh);
	sigh.x = 612;
	sigh.y = 519.5;
	sigh.width = 67.50;
	sigh.height = 74.00;
	sigh.alpha = 1.00;
	if (sigh.onLayout) sigh.onLayout();
	const amy = this.amy;
	ch2_p08_hh_ch2_p08psdAssetP8amy.call(this.amy);
	amy.x = 955.75;
	amy.y = 640;
	amy.width = 465.50;
	amy.height = 768.00;
	amy.alpha = 1.00;
	if (amy.onLayout) amy.onLayout();
	const oscar = this.oscar;
	ch2_p08_hh_ch2_p08psdAssetP8oscar.call(this.oscar);
	oscar.x = 1266;
	oscar.y = 644;
	oscar.width = 576.00;
	oscar.height = 768.00;
	oscar.alpha = 1.00;
	if (oscar.onLayout) oscar.onLayout();
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8bg(this: Ich2_p08_hh_ch2_p08psdAssetP8bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p09psdAsset1chp2_p09_hollytablechairs(this: Ich2_p08_hh_ch2_p09psdAsset1chp2_p09_hollytablechairs) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p09_hollytablechairs", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8Holly(this: Ich2_p08_hh_ch2_p08psdAssetP8Holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("Holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyback(this: Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyback) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p09_hollyback", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8table(this: Ich2_p08_hh_ch2_p08psdAssetP8table) {
	if (this.setLayoutTexture) this.setLayoutTexture("table", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p08psdAsset1P8phone(this: Ich2_p08_hh_ch2_p08psdAsset1P8phone) {
	if (this.setLayoutTexture) this.setLayoutTexture("phone", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8frameL(this: Ich2_p08_hh_ch2_p08psdAssetP8frameL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8frameR(this: Ich2_p08_hh_ch2_p08psdAssetP8frameR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8framelines(this: Ich2_p08_hh_ch2_p08psdAssetP8framelines) {
	if (this.setLayoutTexture) this.setLayoutTexture("lines", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8hollyarms(this: Ich2_p08_hh_ch2_p08psdAssetP8hollyarms) {
	if (this.setLayoutTexture) this.setLayoutTexture("hollyarms", 0.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyfront(this: Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p09_hollyfront", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p09psdAssetchp2_p09_sigh(this: Ich2_p08_hh_ch2_p09psdAssetchp2_p09_sigh) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp2_p09_sigh", 0.000, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8amy(this: Ich2_p08_hh_ch2_p08psdAssetP8amy) {
	if (this.setLayoutTexture) this.setLayoutTexture("amy", 0.501, 0.833);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch2_p08_hh_ch2_p08psdAssetP8oscar(this: Ich2_p08_hh_ch2_p08psdAssetP8oscar) {
	if (this.setLayoutTexture) this.setLayoutTexture("oscar", 0.500, 0.839);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich2_p08Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich2_p08Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich2_p08Sprite extends Ich2_p08Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich2_p08Text extends Ich2_p08Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich2_p08Polygon extends Array<number> {
}
interface Ich2_p08 {
	readonly hollyBack: Ich2_p08Array<Ich2_p08_hh_ch2_p08psdAssetP8Holly|Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyback>;
	readonly hollyFront: Ich2_p08Array<Ich2_p08_hh_ch2_p08psdAssetP8hollyarms|Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyfront>;
	readonly bg: Ich2_p08_hh_ch2_p08psdAssetP8bg;
	readonly chairs: Ich2_p08_hh_ch2_p09psdAsset1chp2_p09_hollytablechairs;
	readonly table: Ich2_p08_hh_ch2_p08psdAssetP8table;
	readonly phone: Ich2_p08_hh_ch2_p08psdAsset1P8phone;
	readonly frameLeft: Ich2_p08_hh_ch2_p08psdAssetP8frameL;
	readonly frameRight: Ich2_p08_hh_ch2_p08psdAssetP8frameR;
	readonly lines: Ich2_p08_hh_ch2_p08psdAssetP8framelines;
	readonly sigh: Ich2_p08_hh_ch2_p09psdAssetchp2_p09_sigh;
	readonly amy: Ich2_p08_hh_ch2_p08psdAssetP8amy;
	readonly oscar: Ich2_p08_hh_ch2_p08psdAssetP8oscar;
}
interface Ich2_p08_hh_ch2_p08psdAssetP8bg extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p09psdAsset1chp2_p09_hollytablechairs extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8Holly extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyback extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8table extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAsset1P8phone extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8frameL extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8frameR extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8framelines extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8hollyarms extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p09psdAsset2chp2_p09_hollyfront extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p09psdAssetchp2_p09_sigh extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8amy extends Ich2_p08Sprite {
}
interface Ich2_p08_hh_ch2_p08psdAssetP8oscar extends Ich2_p08Sprite {
}
